import { render, staticRenderFns } from "./CompanyInfoDossiers.vue?vue&type=template&id=0a3cffe1&"
import script from "./CompanyInfoDossiers.vue?vue&type=script&lang=ts&"
export * from "./CompanyInfoDossiers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a3cffe1')) {
      api.createRecord('0a3cffe1', component.options)
    } else {
      api.reload('0a3cffe1', component.options)
    }
    module.hot.accept("./CompanyInfoDossiers.vue?vue&type=template&id=0a3cffe1&", function () {
      api.rerender('0a3cffe1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/company/CompanyInfoDossiers.vue"
export default component.exports